// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__188uj","title":"style_title__2P-Xh","totalContainer":"style_totalContainer__1RHsd","totalText":"style_totalText__2kORi"};